var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "llm-configuration" },
    [
      _c(
        "div",
        { staticClass: "llm-button-group" },
        [
          _c(
            "div",
            {
              staticClass: "llm-selector-btn",
              on: { click: _vm.openModelSelector },
            },
            [
              _c("div", { staticClass: "btn-content" }, [
                _c("div", { staticClass: "model-info" }, [
                  _c("i", { staticClass: "material-icons model-icon" }, [
                    _vm._v("psychology"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "model-name" }, [
                    _vm._v(_vm._s(_vm.selectedModelName)),
                  ]),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("expand_more"),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: {
                placement: "topLeft",
                visible: _vm.isSettingsVisible,
                trigger: ["click"],
                overlayClassName: "llm-settings-popover",
              },
              on: { visibleChange: _vm.handleSettingsVisibleChange },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "llm-settings" }, [
                  _c("h3", { staticClass: "settings-title" }, [
                    _vm._v(_vm._s(_vm.$t("voiceagent.modelSettings"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "settings-section" },
                    [
                      _c("div", { staticClass: "slider-header" }, [
                        _c("h4", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.$t("voiceagent.llmTemperature"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatTemperature(_vm.localModelTemperature)
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a-slider", {
                        attrs: { min: 0, max: 1, step: 0.01 },
                        model: {
                          value: _vm.localModelTemperature,
                          callback: function ($$v) {
                            _vm.localModelTemperature = $$v
                          },
                          expression: "localModelTemperature",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "slider-description" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t("voiceagent.llmTemperatureDescription")
                            ) +
                            "\n                        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "settings-section" }, [
                    _c(
                      "div",
                      { staticClass: "setting-checkbox" },
                      [
                        _c("h4", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.$t("voiceagent.structuredOutput"))),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          model: {
                            value: _vm.localToolCallStrictMode,
                            callback: function ($$v) {
                              _vm.localToolCallStrictMode = $$v
                            },
                            expression: "localToolCallStrictMode",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "setting-description" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t("voiceagent.structuredOutputDescription")
                          ) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "action-buttons" },
                    [
                      _c("a-button", { on: { click: _vm.resetSettings } }, [
                        _vm._v(_vm._s(_vm.$t("voiceagent.cancel"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "PermissionController",
                        { attrs: { permissions: ["voice-agent.update"] } },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.saveSettings },
                            },
                            [_vm._v(_vm._s(_vm.$t("voiceagent.save")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "llm-settings-btn" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("settings"),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Model Seçimi",
            footer: null,
            width: 1000,
            wrapClassName: "llm-model-selector-modal",
          },
          on: {
            cancel: function ($event) {
              _vm.isModelSelectorVisible = false
            },
          },
          model: {
            value: _vm.isModelSelectorVisible,
            callback: function ($$v) {
              _vm.isModelSelectorVisible = $$v
            },
            expression: "isModelSelectorVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "model-selector llm-model-selector-modal-content" },
            [
              _c("div", { staticClass: "model-columns" }, [
                _c("div", { staticClass: "model-column" }, [
                  _c("div", { staticClass: "column-header" }, [
                    _c("div", { staticClass: "provider-logo-large" }, [
                      _c("img", {
                        attrs: {
                          src: "https://static.supsis.live/common/image/openai.svg",
                          alt: "OpenAI",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "column-title" }, [
                      _vm._v("OpenAI"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "model-list" },
                    _vm._l(_vm.modelOptions.openai, function (model) {
                      return _c("div", { key: model.id }, [
                        _c(
                          "div",
                          {
                            staticClass: "model-item",
                            class: {
                              selected: _vm.isModelSelected(model.id, false),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectModel(model.id, false)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "model-content" }, [
                              _c("div", { staticClass: "model-header" }, [
                                _c("div", { staticClass: "model-name" }, [
                                  _vm._v(_vm._s(model.name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tier-badge default" },
                                  [_vm._v("Default")]
                                ),
                                _vm._v(" "),
                                _vm.isModelSelected(model.id, false)
                                  ? _c(
                                      "span",
                                      { staticClass: "selected-badge" },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check_circle")]
                                        ),
                                        _vm._v(
                                          " Seçili\n                                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "model-price" }, [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.formatCustomerLlmPerMin(
                                        model.defaultPrice,
                                        model.price
                                      )
                                    ) +
                                    "/dk"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "model-actions" },
                              [
                                model.realtime
                                  ? _c(
                                      "a-tooltip",
                                      { attrs: { placement: "right" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(
                                                "• Maksimum çağrı süresi: 30 dk"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "• Telaffuz sözlüğü: desteklenmiyor"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "• Konuşma normalizasyonu: desteklenmiyor"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "• Yedek ses kimliği: desteklenmiyor"
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons info-icon",
                                          },
                                          [_vm._v("info")]
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        model.hasFastTier
                          ? _c(
                              "div",
                              {
                                staticClass: "model-item fast-tier",
                                class: {
                                  selected: _vm.isModelSelected(model.id, true),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectModel(model.id, true)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "model-content" }, [
                                  _c("div", { staticClass: "model-header" }, [
                                    _c("div", { staticClass: "model-name" }, [
                                      _vm._v(_vm._s(model.name)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "tier-badge fast" },
                                      [_vm._v("Fast")]
                                    ),
                                    _vm._v(" "),
                                    _vm.isModelSelected(model.id, true)
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "selected-badge fast",
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("check_circle")]
                                            ),
                                            _vm._v(
                                              " Seçili\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "model-price" }, [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          _vm.formatCustomerLlmPerMin(
                                            model.fastPrice
                                          )
                                        ) +
                                        "/dk"
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "model-column" }, [
                  _c("div", { staticClass: "column-header" }, [
                    _c("div", { staticClass: "provider-logo-large" }, [
                      _c("img", {
                        attrs: {
                          src: "https://static.supsis.live/common/image/claude-color.svg",
                          alt: "Claude",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "column-title" }, [
                      _vm._v("Claude"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "model-list" },
                    _vm._l(_vm.modelOptions.claude, function (model) {
                      return _c(
                        "div",
                        {
                          key: model.id,
                          staticClass: "model-item",
                          class: {
                            selected: _vm.isModelSelected(model.id, false),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectModel(model.id, false)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "model-content" }, [
                            _c("div", { staticClass: "model-header" }, [
                              _c("div", { staticClass: "model-name" }, [
                                _vm._v(_vm._s(model.name)),
                              ]),
                              _vm._v(" "),
                              _vm.isModelSelected(model.id, false)
                                ? _c(
                                    "span",
                                    { staticClass: "selected-badge" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("check_circle")]
                                      ),
                                      _vm._v(
                                        " Seçili\n                                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "model-price" }, [
                              _vm._v(
                                "$" +
                                  _vm._s(
                                    _vm.formatCustomerLlmPerMin(
                                      model.defaultPrice,
                                      model.price
                                    )
                                  ) +
                                  "/dk"
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "model-column" }, [
                  _c("div", { staticClass: "column-header" }, [
                    _c("div", { staticClass: "provider-logo-large" }, [
                      _c("img", {
                        attrs: {
                          src: "https://static.supsis.live/common/image/gemini-color.svg",
                          alt: "Gemini",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "column-title" }, [
                      _vm._v("Gemini"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "model-list" },
                    _vm._l(_vm.modelOptions.gemini, function (model) {
                      return _c(
                        "div",
                        {
                          key: model.id,
                          staticClass: "model-item",
                          class: {
                            selected: _vm.isModelSelected(model.id, false),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectModel(model.id, false)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "model-content" }, [
                            _c("div", { staticClass: "model-header" }, [
                              _c("div", { staticClass: "model-name" }, [
                                _vm._v(_vm._s(model.name)),
                              ]),
                              _vm._v(" "),
                              _vm.isModelSelected(model.id, false)
                                ? _c(
                                    "span",
                                    { staticClass: "selected-badge" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("check_circle")]
                                      ),
                                      _vm._v(
                                        " Seçili\n                                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "model-price" }, [
                              _vm._v(
                                "$" +
                                  _vm._s(
                                    _vm.formatCustomerLlmPerMin(
                                      model.defaultPrice,
                                      model.price
                                    )
                                  ) +
                                  "/dk"
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }